module.exports = __webpack_public_path__ + "static/media/lokmanyaweb-3.87762811.png";